import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setDrawerAlert } from 'slices/drawer'
import { readUnreadMessages } from 'slices/messages'
import {
  EMPTY_NOTIFICATIONS_MESSAGE,
  NOTIFICATION_DEFAULT_CATEGORIES,
  NOTIFICATION_DEFAULT_CATEGORIES_LABEL,
} from 'app-constants'
import { CarouselNew, ContextLoader } from 'components'
import { STATICS } from 'statics'
import { MessageCategory } from '../category'
import { MessageItem } from '../message-item'
import { READ_ALL_MESSAGES_ERROR_MESSAGE, READ_ALL_MESSAGES_SUCCESS_MESSAGE } from '../../constants'
import './style.scss'

export function Messages({ messages, setSelected, selectedCategory, setSelectedCategory }) {
  const { categories, contentUnread, content, isLoading } = messages
  const [displayMessages, setDisplayMessages] = useState(content)
  const [isLoadingReadAllMessages, setIsLoadingReadAllMessages] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    function getFilteredMessages() {
      switch (selectedCategory) {
        case NOTIFICATION_DEFAULT_CATEGORIES.ALL:
          return content
        case NOTIFICATION_DEFAULT_CATEGORIES.UNREAD:
          return contentUnread
        default:
          return content.filter(message => message.category === selectedCategory)
      }
    }

    const filteredMessages = getFilteredMessages()
    setDisplayMessages(filteredMessages)
  }, [content, contentUnread, selectedCategory])

  async function handleReadAllClick() {
    try {
      setIsLoadingReadAllMessages(true)
      await dispatch(readUnreadMessages()).unwrap()
      dispatch(
        setDrawerAlert({
          severity: 'success',
          title: READ_ALL_MESSAGES_SUCCESS_MESSAGE,
        })
      )
    } catch (error) {
      console.error(error)

      dispatch(setDrawerAlert({ severity: 'error', title: READ_ALL_MESSAGES_ERROR_MESSAGE }))
    } finally {
      setIsLoadingReadAllMessages(false)
    }
  }

  function getIsReadAllButtonDisabled() {
    const noUnreadMessages = contentUnread.length === 0
    return noUnreadMessages || isLoadingReadAllMessages
  }

  function renderCategory([name, unreadMessages]) {
    return (
      <MessageCategory
        key={name}
        id={name}
        name={name}
        selected={selectedCategory}
        setSelected={setSelectedCategory}
        size={unreadMessages}
      />
    )
  }

  function renderDefaultCategory(category, size = 0) {
    return (
      <MessageCategory
        id={category}
        name={NOTIFICATION_DEFAULT_CATEGORIES_LABEL[category]}
        selected={selectedCategory}
        setSelected={setSelectedCategory}
        size={size}
      />
    )
  }

  function renderCarouselCategories() {
    const categoryEntries = Object.entries(categories)
    return (
      <CarouselNew variableWidth slidesToScroll='auto'>
        {renderDefaultCategory(NOTIFICATION_DEFAULT_CATEGORIES.ALL)}
        {renderDefaultCategory(NOTIFICATION_DEFAULT_CATEGORIES.UNREAD, contentUnread.length)}
        {categoryEntries.map(renderCategory)}
      </CarouselNew>
    )
  }

  function renderMessagesByFilter() {
    if (displayMessages.length === 0) {
      return <p className='empty-messages-container'>{EMPTY_NOTIFICATIONS_MESSAGE}</p>
    }

    return displayMessages.map(message => (
      <MessageItem key={message.id} message={message} setSelected={setSelected} />
    ))
  }

  if (isLoading) return <ContextLoader fixed={false} />

  return (
    <div className='messages-container'>
      <div className='categories-container'>{renderCarouselCategories()}</div>
      <div className='container-read-all'>
        <button
          disabled={getIsReadAllButtonDisabled()}
          type='button'
          className='button'
          onClick={handleReadAllClick}
        >
          <span className='real-all'>Marcar como lidas</span>
          <STATICS.BLUE_CHECK />
        </button>
      </div>
      <div className='messages-list'> {renderMessagesByFilter()}</div>
    </div>
  )
}
